export class EditProfileModel {
  public id:string;
  public firstName: string = '';
  public lastName: string = '';
  public companyName: string = '';
  public phone: string = '';
  public email: string = '';
  public address: string = '';
  public profilePictureUrl: string = '';
}
